import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Menu',
  basePath: '/menu',
  reorderable: true,
  columns: [
    { key: 'label', label: 'Label' },
    { key: 'path', label: 'Path' },
  ],
  fields: [
    { key: 'label', label: 'Label', type: 'text', required: true },
    { key: 'path', label: 'Path', type: 'text' },
    { key: 'parent_id', label: 'Parent', type: 'async-select',
      optionsUrl: '/menu/options', allowClear: true },
    { key: 'icon_id', label: 'Icon', type: 'async-select',
      optionsUrl: '/icons/options', iconProp: 'image', iconAs: 'image',
      allowClear: true, eagerLoadOptions: true },
  ],
});
